import React, { useCallback, useState } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import TextInput from 'fe-design-base/atoms/TextInput';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import {
  EVENT_ACTIONS,
  trackTimecardClick,
} from 'features/timesheets/tracking';

import { cxHelpers } from 'util/className';

import Section from '../../Section';

const { cx, cxEl } = cxHelpers('BreakPenalty');

const BreakPenaltyInput = ({ onChange, breakPenalty, setChangesMade }) => {
  const [value, setValue] = useState(breakPenalty);

  const handleBreakPenalty = useCallback(
    v => {
      onChange('break_penalty', v !== '' ? parseFloat(v) : null);
    },
    [onChange]
  );

  const handleChange = useCallback(
    e => {
      setChangesMade(true);
      setValue(e.target.value);
      handleBreakPenalty(e.target.value);
    },
    [handleBreakPenalty, setChangesMade]
  );

  return (
    <Section
      className={cx()}
      bottomPadding
      title={
        <Text
          i18n="timecard_modal_v3.timebreaks_section.break_penalty"
          variant="bodySmBoldTight"
          color="mono700"
        />
      }
      collapsedContent={
        <Box pt={8} className={cxEl('break-penalty-input')}>
          <Box vcenter>
            <Box
              mr={5}
              w={48}
              onClick={partial(trackTimecardClick, {
                eventAction: EVENT_ACTIONS.BREAK_PENALTY_CLICKED,
              })}
            >
              <TextInput
                size="medium"
                name="break_penalty"
                type="number"
                value={value}
                onChange={handleChange}
                valueOnChange
              />
            </Box>
            <Box>
              <Text
                i18n="timecard_modal_v3.timebreaks_section.hour"
                color="mono900"
              />
            </Box>
          </Box>
        </Box>
      }
      bottomBorder
    />
  );
};

BreakPenaltyInput.propTypes = {
  breakPenalty: PropTypes.number,
  onChange: PropTypes.func,
  setChangesMade: PropTypes.func.isRequired,
};

export default BreakPenaltyInput;
